import { Label } from "components/label";
import { get } from "lodash";
import { DetailGroupType } from "routes/group/types";

interface PropType {
  data: DetailGroupType;
}

const VatDetailForm = (props: PropType) => {
  const { data } = props;

  return (
    <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8">
      <div className="flex flex-col gap-1">
        <Label required={false} id="vat.company_name" name="Company Name" />

        <span className="text-[14px]">{get(data, "vat.company_name", "")}</span>
      </div>

      <div className="flex flex-col gap-1">
        <Label
          required={false}
          id="vat.company_address"
          name="Company Address"
        />

        <span className="text-[14px]">
          {get(data, "vat.company_address", "")}
        </span>
      </div>

      <div className="flex flex-col gap-1">
        <Label
          required={false}
          id="vat.company_tax_code"
          name="Company Tax Code"
        />

        <span className="text-[14px]">
          {get(data, "vat.company_tax_code", "")}
        </span>
      </div>

      <div className="flex flex-col gap-1">
        <Label required={false} id="vat.recipient_name" name="Recipient Name" />

        <span className="text-[14px]">
          {get(data, "vat.recipient_name", "")}
        </span>
      </div>

      <div className="flex flex-col gap-1">
        <Label
          required={false}
          id="vat.recipient_phone"
          name="Recipient Phone"
        />

        <span className="text-[14px]">
          {get(data, "vat.recipient_phone", "")}
        </span>
      </div>

      <div className="flex flex-col gap-1">
        <Label
          required={false}
          id="vat.recipient_address"
          name="Recipient Address"
        />

        <span className="text-[14px]">
          {get(data, "vat.recipient_address", "")}
        </span>
      </div>
    </section>
  );
};

export default VatDetailForm;
